import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentoFormat',
  standalone: true
})
export class DocumentoFormatPipe implements PipeTransform {
  transform(value: string | number | null | undefined, tipo: string): string {
    if (!value) return '';

    let valorStr = value.toString().replace(/\D/g, '');

    if (tipo?.toUpperCase().includes('CPF')) {
      if (valorStr.length === 11) {
        return valorStr.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
    } else if (tipo?.toUpperCase().includes('CNPJ')) {
      if (valorStr.length === 14) {
        return valorStr.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
    }

    return value.toString();
  }
}
